module.exports = __webpack_public_path__ + "static/media/quote-blue.102de20f.svg";